export const chatHistoryResources = {
  "zh-CN": {
    chat: {
      chatHistory: {
        conversationList: {
          title: "对话",
          actions: {
            rename: "重命名",
            pin: "置顶",
            unpin: "取消置顶",
            favorite: "收藏",
            unfavorite: "取消收藏",
            delete: "删除",
            newConversation: "新建对话",
            search: "搜索对话",
          },
          filters: {
            all: "全部",
            pinned: "置顶",
            favorite: "收藏",
          },
          dateGroups: {
            today: "今天",
            yesterday: "昨天",
            week: "7 天内",
            older: "更早",
          },
        },
        search: {
          title: "搜索对话",
          placeholder: "搜索对话标题或内容…",
          noMatches: "未找到匹配的对话",
          empty: "暂无对话记录",
          clearQuery: "清除搜索内容",
          yesterday: "昨天",
          daysAgo_one: "{{count}} 天前",
          daysAgo_other: "{{count}} 天前",
        },
        debug: {
          panelLabel: "调用记录",
          events: {
            modelRequest: "模型请求 · 第 {{requestNo}} 轮",
            modelResponse: "模型响应 · 第 {{requestNo}} 轮",
            toolStart: "调用工具 {{toolName}}",
            toolResult: "工具返回 {{toolName}}",
            error: "执行协议或工具结果异常",
            interrupted: "执行中断或失败",
            eventsTruncated: "调试记录达到上限",
            recoveryStarted: "工具协议异常，使用已有证据进行一次纯作答恢复",
            recoveryCompleted: "纯作答恢复完成",
            recoveryFailed: "纯作答恢复未完成，不再重试",
            initialKnowledgeFailure: "初次知识检索失败",
            initialKnowledgeCompleted: "初次知识检索与正文整理",
            answerCompleted: "回答生成结束",
            answerFailure: "回答执行失败",
            retrievalTotals: "检索累计",
          },
          statisticsLabel: "执行统计",
          stats: {
            model: "模型 {{value}}",
            retrieval: "检索 {{value}}",
            tools: "工具 {{value}}",
            reportedTokens: "已报告 Token {{value}}",
            recordDuration: "记录时段 {{value}} 秒",
            collecting: "采集中",
          },
          filterLabel: "调试记录分类",
          filters: {
            all: "全部",
            model: "模型",
            retrieval: "检索",
            tool: "工具",
            error: "异常",
          },
          copyAll: "复制本条回复全部记录",
          copySuccess: "已复制脱敏记录",
          copyFailure: "复制失败，请直接选择详情中的文字",
          summary: {
            failed: "失败",
            returned: "已返回",
            executing: "执行中",
            noResult: "未收到结果",
            model: "模型",
            query: "查询",
            durationMs: "耗时 ms",
            evidenceChunks: "证据块",
            newFindings: "新增证据",
            reusedFindings: "复用证据",
            finish: "结束",
            reason: "原因",
            error: "错误",
            tokens: "Token",
            cacheHit: "缓存命中",
            cacheMiss: "未命中缓存",
          },
          searchLabel: "搜索调试记录",
          searchPlaceholder: "搜索参数、来源 ID 或错误",
          resultCount: "{{filtered}} / {{total}} 条",
          runtimeInfo: "运行信息",
          traceId: "追踪 ID：{{id}}",
          rawEventCount_one: "原始事件 {{count}} 条，仅当前页面保留；记录时段不等于总响应耗时。",
          rawEventCount_other: "原始事件 {{count}} 条，仅当前页面保留；记录时段不等于总响应耗时。",
          empty: "本条回复没有详细记录。开启详细记录后发送测试问题。",
          noMatches: "没有匹配的调试记录",
          truncated: "部分省略",
          eventFallback: "事件 {{sequence}}",
          structured: "结构化",
          rawJson: "原始 JSON",
          copyOne: "复制 {{label}}",
        },
        debugPayload: {
          fields: {
            systemPrompt: "系统指令",
            messages: "消息",
            tools: "工具定义",
            content: "内容",
            text: "正文",
            role: "角色",
            input: "调用参数",
            output: "返回结果",
            result: "结果",
            details: "详情",
            usage: "Token 用量",
            totalTokens: "总 Token",
            inputTokens: "输入 Token",
            outputTokens: "输出 Token",
            model: "模型",
            query: "查询",
            knowledgeBaseId: "知识库 ID",
            documentId: "文件 ID",
            blockId: "Block ID",
            documentName: "文件名",
            sources: "来源",
            citations: "引用",
            findings: "证据",
            items: "条目",
            evidence: "证据",
            results: "结果",
            durationMs: "耗时（ms）",
            status: "状态",
            toolName: "工具",
            toolCallId: "调用 ID",
            requestNo: "模型请求轮次",
            stopReason: "结束原因",
            failureCategory: "失败类型",
            reason: "原因",
            error: "错误",
            cacheHit: "缓存命中",
            newFindings: "新增证据",
            reusedFindings: "复用证据",
            coreSearchInvocations: "实际检索次数",
          },
          payloadTruncated: "记录部分省略，仅展示已采集内容。",
          collapseText: "收起正文",
          expandText: "已显示 800 / {{count}} 字符，展开",
          itemFallback: "条目 {{index}}",
        },
      },
    },
  },
  "en-US": {
    chat: {
      chatHistory: {
        conversationList: {
          title: "Conversations",
          actions: {
            rename: "Rename",
            pin: "Pin",
            unpin: "Unpin",
            favorite: "Add to favorites",
            unfavorite: "Remove from favorites",
            delete: "Delete",
            newConversation: "New conversation",
            search: "Search conversations",
          },
          filters: {
            all: "All",
            pinned: "Pinned",
            favorite: "Favorites",
          },
          dateGroups: {
            today: "Today",
            yesterday: "Yesterday",
            week: "Last 7 days",
            older: "Older",
          },
        },
        search: {
          title: "Search conversations",
          placeholder: "Search conversation titles or content…",
          noMatches: "No matching conversations found",
          empty: "No conversations yet",
          clearQuery: "Clear search",
          yesterday: "Yesterday",
          daysAgo_one: "{{count}} day ago",
          daysAgo_other: "{{count}} days ago",
        },
        debug: {
          panelLabel: "Call records",
          events: {
            modelRequest: "Model request · round {{requestNo}}",
            modelResponse: "Model response · round {{requestNo}}",
            toolStart: "Calling tool {{toolName}}",
            toolResult: "Tool result · {{toolName}}",
            error: "Execution protocol or tool result error",
            interrupted: "Execution interrupted or failed",
            eventsTruncated: "Debug event limit reached",
            recoveryStarted: "Recovering the answer with available evidence after a tool protocol error",
            recoveryCompleted: "Answer recovery completed",
            recoveryFailed: "Answer recovery failed; no further retries",
            initialKnowledgeFailure: "Initial knowledge retrieval failed",
            initialKnowledgeCompleted: "Initial knowledge retrieval and content review",
            answerCompleted: "Answer generation completed",
            answerFailure: "Answer generation failed",
            retrievalTotals: "Retrieval totals",
          },
          statisticsLabel: "Execution statistics",
          stats: {
            model: "Models {{value}}",
            retrieval: "Searches {{value}}",
            tools: "Tools {{value}}",
            reportedTokens: "Reported tokens {{value}}",
            recordDuration: "Record span {{value}} sec",
            collecting: "Collecting",
          },
          filterLabel: "Debug record categories",
          filters: {
            all: "All",
            model: "Model",
            retrieval: "Search",
            tool: "Tool",
            error: "Errors",
          },
          copyAll: "Copy all records for this reply",
          copySuccess: "Sanitized records copied",
          copyFailure: "Could not copy. Select the text in the details directly.",
          summary: {
            failed: "Failed",
            returned: "Returned",
            executing: "Running",
            noResult: "No result received",
            model: "Model",
            query: "Query",
            durationMs: "Duration ms",
            evidenceChunks: "Evidence chunks",
            newFindings: "New findings",
            reusedFindings: "Reused findings",
            finish: "Finish",
            reason: "Reason",
            error: "Error",
            tokens: "Tokens",
            cacheHit: "Cache hit",
            cacheMiss: "Cache miss",
          },
          searchLabel: "Search debug records",
          searchPlaceholder: "Search parameters, source IDs, or errors",
          resultCount: "{{filtered}} / {{total}} records",
          runtimeInfo: "Run information",
          traceId: "Trace ID: {{id}}",
          rawEventCount_one: "{{count}} raw event retained on this page. Record span is not the total response time.",
          rawEventCount_other: "{{count}} raw events retained on this page. Record span is not the total response time.",
          empty: "No detailed records for this reply. Turn on detailed recording and send a test message.",
          noMatches: "No matching debug records",
          truncated: "Partially omitted",
          eventFallback: "Event {{sequence}}",
          structured: "Structured",
          rawJson: "Raw JSON",
          copyOne: "Copy {{label}}",
        },
        debugPayload: {
          fields: {
            systemPrompt: "System instructions",
            messages: "Messages",
            tools: "Tool definitions",
            content: "Content",
            text: "Text",
            role: "Role",
            input: "Input parameters",
            output: "Output",
            result: "Result",
            details: "Details",
            usage: "Token usage",
            totalTokens: "Total tokens",
            inputTokens: "Input tokens",
            outputTokens: "Output tokens",
            model: "Model",
            query: "Query",
            knowledgeBaseId: "Knowledge base ID",
            documentId: "File ID",
            blockId: "Block ID",
            documentName: "File name",
            sources: "Sources",
            citations: "Citations",
            findings: "Findings",
            items: "Items",
            evidence: "Evidence",
            results: "Results",
            durationMs: "Duration (ms)",
            status: "Status",
            toolName: "Tool",
            toolCallId: "Tool call ID",
            requestNo: "Model request number",
            stopReason: "Stop reason",
            failureCategory: "Failure category",
            reason: "Reason",
            error: "Error",
            cacheHit: "Cache hit",
            newFindings: "New findings",
            reusedFindings: "Reused findings",
            coreSearchInvocations: "Search calls made",
          },
          payloadTruncated: "Part of the record is omitted; only collected content is shown.",
          collapseText: "Collapse text",
          expandText: "Showing 800 / {{count}} characters. Expand",
          itemFallback: "Item {{index}}",
        },
      },
    },
  },
} as const;
